import { __assign } from "tslib";
import * as React from 'react';
export function renderJsonLd(data) {
    if (data === undefined) {
        return undefined;
    }
    var content = __assign({ '@context': 'http://schema.org' }, data);
    return (React.createElement("script", { key: "JsonLd", type: "application/ld+json" }, JSON.stringify(content, undefined, 2)));
}
